export default {
  ourRecommandations: {
    id: 'buying_guide_our_recommendations',
    defaultMessage: 'Here are ours',
  },
  relatedArticles: {
    id: 'buying_guide_related_articles_title',
    defaultMessage: 'Related articles',
  },
  prevSlideText: {
    id: 'buying_guide_slider_prev_slide',
    defaultMessage: 'Display previous slide',
  },
  nextSlideText: {
    id: 'buying_guide_slider_next_slide',
    defaultMessage: 'Display next slide',
  },
}
